"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutPelvicHealthPhysiotherapy() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section id="about-pelvic-health-physiotherapy" className="bg-background relative pt-16 md:pt-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          
          {}
          <div ref={imageRef} className={`lg:col-span-5 transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative w-full aspect-[4/5] rounded-lg overflow-hidden shadow-medium">
              <img src="https://alignphysiotherapy.co.uk/wp-content/uploads/2026/03/Clinic-Room-Picture.jpeg" alt="Modern, comfortable pelvic health treatment room" className="w-full h-full object-cover" />
              {}
              <div className="absolute inset-0 border border-border/10 rounded-lg pointer-events-none"></div>
            </div>
          </div>

          {}
          <div ref={textRef} className={`lg:col-span-7 space-y-8 transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-6">
              <h2 className="text-primary font-display text-3xl md:text-4xl lg:text-5xl leading-[1.3] tracking-wide">
                Restoring Confidence & Function
              </h2>
              
              <div className="space-y-4 text-foreground/80 text-base md:text-lg leading-[1.6] font-sans max-w-3xl">
                <p>Pelvic health physiotherapy is a specialised branch of care dedicated to treating conditions related to the pelvic floor. We understand that these issues can be deeply personal and impactful on your daily life.</p>
                <p>
                  Our modern, comfortable treatment rooms provide a safe, private, and welcoming environment where you can openly discuss your concerns. Whether you are experiencing discomfort, recovering from childbirth, or managing a chronic condition, our evidence-based approach focuses on restoring your confidence and improving your overall function.
                </p>
                <p>
                  We tailor every treatment plan to your unique needs, ensuring you receive the highest standard of compassionate care on your journey to wellness.
                </p>
              </div>
            </div>

            <div className="pt-4">
              <Link to="/ServicesPage">
                <Button size="lg" className="group">
                  Explore Our Services
                  <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                </Button>
              </Link>
            </div>
          </div>

        </div>
      </div>

      {}
      <div className="container mx-auto px-4 md:px-6 mt-16 md:mt-24">
        <Separator className="bg-muted/50" />
      </div>
    </section>;
}